// 3rd-party 주입 스크립트·인앱브라우저·익스텐션 등 우리가 제어할 수 없고 알람 가치가 없는
// 노이즈 패턴 목록. beforeSend 에서 매칭되면 이벤트를 드롭합니다.
//
// 추가 시 원칙: 우리 코드가 아니라는 것이 명백한 경우에만 추가. 사용자 환경 이슈여도
// 우리 코드 동작에 단서가 되는 것(localStorage 차단, Failed to fetch 등)은 유지합니다.

// exception.values[*].value 부분 일치
const NOISE_EXCEPTION_VALUES = [
  // Safari/WebKit: 인앱브라우저·콘텐츠 차단기가 native globals 패치 시도
  'Attempting to change value of a readonly property',
  // Firefox iOS 리더 모드 주입
  'window.__firefox__',
  // Web3 지갑 익스텐션 (MetaMask 등)
  'window.ethereum',
  // 외부 스크립트가 jQuery 기대 (우리 페이지는 jQuery 미사용)
  'jQuery is not defined',
  // 베트남 Zalo 인앱브라우저
  'Can\'t find variable: zaloJSV2',
  // iOS WebKit 익스텐션 (Highlights)
  'Can\'t find variable: WKWebView_RemoveAllHighlights',
  // 외부 주입 스크립트가 참조하는 미정의 전역
  'MOBILE is not defined',
  'unSelectAll is not defined',
  'xbrowser is not defined',
  // 잘 알려진 브라우저 false positive
  'ResizeObserver loop completed',
  // UC Browser 인앱 sniff 스크립트
  'ucSniffAgain',
  // Android WebView bridge 노이즈
  'Java bridge method invocation error',
]

// event.transaction / event.culprit / stack 부분 일치
const NOISE_LOCATIONS = [
  // Tencent WeGame/WattToolkit 인젝션
  'WattToolkit_Inject',
  // UC Browser 인앱 주입
  'ucbrowser_script',
  // Safari WebKit 이 익명화한 외부 URL (대개 컨텐츠 블로커·익스텐션)
  '@webkit-masked-url',
]

function matchesExceptionValue(event) {
  const values = event?.exception?.values
  if (!Array.isArray(values)) return false
  return values.some((v) => typeof v?.value === 'string'
    && NOISE_EXCEPTION_VALUES.some((pattern) => v.value.includes(pattern)))
}

function matchesLocation(event, hint) {
  const candidates = [event?.transaction, event?.culprit, hint?.originalException?.stack]
  return candidates.some((s) => typeof s === 'string'
    && NOISE_LOCATIONS.some((pattern) => s.includes(pattern)))
}

/**
 * @returns {boolean} true 면 beforeSend 에서 null 반환하여 이벤트 드롭
 */
export default function shouldDropEvent(event, hint) {
  return matchesExceptionValue(event) || matchesLocation(event, hint)
}
